function DominicanRepublic({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_1090)">
  <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#F0F0F0"/>
  <path d="M0.551147 20.1738C2.02852 25.6553 6.34458 29.9714 11.8261 31.4488V20.1738H0.551147Z" fill="#D80027"/>
  <path d="M11.826 0.550781C6.34458 2.02809 2.02846 6.34422 0.551147 11.8257H11.8261V0.550781H11.826Z" fill="#0052B4"/>
  <path d="M31.4488 11.8257C29.9715 6.34422 25.6554 2.02809 20.174 0.550781V11.8257H31.4488V11.8257Z" fill="#D80027"/>
  <path d="M20.174 31.4488C25.6554 29.9714 29.9715 25.6553 31.4489 20.1738H20.174V31.4488Z" fill="#0052B4"/>
  <path d="M20.1739 16.0001C20.1739 18.3054 18.3052 20.174 16 20.174C13.6948 20.174 11.826 18.3054 11.826 16.0001C11.826 13.6949 16 11.8262 16 11.8262C16 11.8262 20.1739 13.6949 20.1739 16.0001Z" fill="#496E2D"/>
  <path d="M11.826 16.0001C11.826 13.6949 13.6948 11.8262 16 11.8262C18.3052 11.8262 20.1739 13.6949 20.1739 16.0001" fill="#0052B4"/>
  <path d="M13.6522 13.9121V16.5208C13.6522 17.8175 14.7033 18.8686 16 18.8686C17.2967 18.8686 18.3478 17.8175 18.3478 16.5208V13.9121H13.6522Z" fill="#D80027"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default DominicanRepublic;
